import {create} from "zustand";
import {BookCommon, IBook, IFetchBooksResult, IFetchHistoryResult, IHistoryBook} from "../models/Book";
import {
    ADD_TO_CART_URL, ADD_TO_FAVOURITE_URL,
    GET_USER_CART_BOOKS_URL,
    GET_USER_FAVOURITE_BOOKS_URL, GET_USER_HISTORY_BOOKS_URL,
    REMOVE_FROM_CART_URL, REMOVE_FROM_FAVOURITE_URL
} from "../utilities/API";
import useAlertStore from "./alertStore";
import {IFetchCommonResult} from "../models/Fetch";
import {redirectToSignInPage} from "../utilities/redirectToSignInPage";

interface IBookList{
    isLoading:boolean,
    books:BookCommon[],
    totalCount:number
}

interface IBookListHistory{
    isLoading:boolean,
    history:{books:IHistoryBook[],totalCount:number},
    inArmsBooks:{books:IHistoryBook[],totalCount:number}
}

export enum ActionType {
    Add,
    Remove
}

interface IUserStore {
    token:string | null,
    fio:string | null,
    login:string | null,
    cart: IBookList,
    favouriteBooks:IBookList,
    historyBooks:IBookListHistory,

    setToken:(token:string)=>void,
    setFIO:(token:string)=>void,
    setLogin:(token:string)=>void,
    logOut:()=>void

    getCart: (limit?:string | null, offset?:string | null, signal?:AbortSignal)=>void,
    cartAction:(book:IBook,actionType:ActionType,signal?:AbortSignal)=>void,
    isBookInCart: (book:BookCommon)=>boolean,

    getFavourite:(limit?:string | null, offset?:string | null, signal?:AbortSignal)=>void,
    isBookInFavourite:(bool:BookCommon)=>boolean,
    favouriteAction:(book:BookCommon,actionType:ActionType,signal?:AbortSignal)=>void,

    getHistory:(limit?:string | null, offset?:string | null, inHand?:boolean,signal?:AbortSignal)=>void,
    //getHistoryBooksInArms:()=>{books:IHistoryBook[],totalCount:number}
}

const useUserStore = create<IUserStore>((set)=>(
    {
        token: localStorage.getItem('token'),
        fio: localStorage.getItem('fio'),
        login: localStorage.getItem('login'),

        cart:{isLoading:false,books:[],totalCount:0},
        favouriteBooks: {isLoading:false,books:[],totalCount:0},
        historyBooks: {isLoading:false,history:{books:[],totalCount:0}, inArmsBooks:{books:[],totalCount:0} },


        setToken : (token => {
            set({token:token});
            localStorage.setItem('token',token);
            // console.log("setToken");
            // console.log(token);
        }),
        setFIO : (fio => {
            set({fio:fio});
            localStorage.setItem('fio',fio);
            // console.log("fio");
            // console.log(fio);
        }),
        setLogin : (login => {
            set({login:login});
            localStorage.setItem('login',login);
            // console.log("setLogin");
            // console.log(login);
        }),
        logOut : ()=>{
            set({token:null,fio:null,login:null});
            localStorage.removeItem("token");
            localStorage.removeItem("fio");
            localStorage.removeItem("login");
        },

        isBookInCart: (book)=>{
          if(book.type != 2)
              return false;

          let index = useUserStore.getState().cart.books.findIndex((value)=>value.id == book.id && value.type == book.type);
          if(index == -1)
              return  false

          return true

        },
        isBookInFavourite:(book)=>{
            let index = useUserStore.getState().favouriteBooks.books.findIndex((value)=>{
                if(book.type != 3) {
                    return value.id == book.id && value.type == book.type;
                }
                else {
                    return value.link == book.link;
                }
            });
            if(index == -1)
                return  false

            return true
        },

        getCart : async (limit,offset,signal)=>{
            if(!useUserStore.getState().token)
                return;

            set({cart:{...useUserStore.getState().cart,isLoading:true}})
            const body = {
                token: useUserStore.getState().token,
                limit,
                offset
            }
            let isAborted = false;
            try {

                await fetch(GET_USER_CART_BOOKS_URL, {
                    signal: signal,
                    method:"POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body:JSON.stringify(body)
                })
                    .then((response)=>response.json() as unknown as IFetchBooksResult)
                    .then((result)=>{
                        if(result.success == false)
                        {
                            if(result.message.includes("Срок действия токена закончено"))
                            {
                                useUserStore.getState().logOut();
                                redirectToSignInPage();
                                return;
                            }
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:result.message},20000);
                            set({cart:{...useUserStore.getState().cart,isLoading:false,books:[],totalCount:0}})
                            return;
                        }
                        set({cart:{isLoading:false,books:result.data.books,totalCount:result.data.count}})
                    })
                    .catch((e) => {
                        if(e.message == "The user aborted a request.")
                        {
                            isAborted = true
                        }
                        else
                        {
                            set({cart:{...useUserStore.getState().cart,isLoading:false}})
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить корзину"},20000)
                        }
                    })

            }
            catch (e)
            {
                set({cart:{...useUserStore.getState().cart,isLoading:false}})
                useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:`${e}`},2000);
                console.log(useUserStore.getState().cart);
                console.log(e);
            }

        },
        cartAction: async (book,actionType,signal)=>{
            if(!useUserStore.getState().token)
                return;

            let body = {
                token:useUserStore.getState().token,
                id:book.id,
                type:book.type
            }

            // console.log(JSON.stringify(body));
            let url = "";
            if(actionType == ActionType.Add){
                url = ADD_TO_CART_URL;
            }
            else if(actionType == ActionType.Remove)
            {
                url = REMOVE_FROM_CART_URL;
            }
            await fetch(url,{
                method:"POST",
                signal:signal,
                body:JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
            })
                .then((response)=>response.json() as unknown as IFetchCommonResult)
                .then((result)=>{
                    if(result.success == false)
                    {
                        if(result.message.includes("Срок действия токена закончено"))
                        {
                            useUserStore.getState().logOut();
                            redirectToSignInPage();
                            return;
                        }
                        useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:result.message},2000);
                        return;
                    }

                    useAlertStore.getState().addAlert({uid:String(Date.now()),type:"success",message:result.message},2000);
                    useUserStore.getState().getCart();
                })
        },

        getFavourite: async (limit,offset,signal)=>{
            if(!useUserStore.getState().token)
                return;

            set({favouriteBooks:{...useUserStore.getState().favouriteBooks,isLoading:true}})
            const body = {
                token: useUserStore.getState().token,
                limit,
                offset
            }
            // console.log(body);
            let isAborted = false;
            try {

                await fetch(GET_USER_FAVOURITE_BOOKS_URL, {
                    signal: signal,
                    method:"POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body:JSON.stringify(body)
                })
                    .then((response)=>response.json() as unknown as IFetchBooksResult)
                    .then((result)=>{
                        if(result.success == false)
                        {
                            if(result.message.includes("Срок действия токена закончено"))
                            {
                                useUserStore.getState().logOut();
                                redirectToSignInPage();
                                return;
                            }
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:result.message},2000);
                            set({favouriteBooks:{...useUserStore.getState().favouriteBooks,isLoading:false,books:[],totalCount:0}})
                            return;
                        }
                        // console.log(result);
                        set({favouriteBooks:{isLoading:false,books:result.data.books,totalCount:result.data.count}})
                    })
                    .catch((e) => {
                        if(e.message === "The user aborted a request.")
                        {
                            isAborted = true
                        }
                        else
                        {
                            set({favouriteBooks:{...useUserStore.getState().favouriteBooks,isLoading:false}})
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить избранное"},20000)
                        }
                    })

            }
            catch (e)
            {
                set({favouriteBooks:{...useUserStore.getState().favouriteBooks,isLoading:false}});
                useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:`${e}`},2000);
                console.log(e);
            }
        },
        favouriteAction: async (book,actionType,signal)=>{
            if(!useUserStore.getState().token)
                return;

            let body = {
                token:useUserStore.getState().token,
                id:book.id,
                link:book.link,
                type:book.type
            }

            // console.log(JSON.stringify(body));
            let url = "";
            if(actionType == ActionType.Add){
                url = ADD_TO_FAVOURITE_URL;
            }
            else if(actionType == ActionType.Remove)
            {
                url = REMOVE_FROM_FAVOURITE_URL;
            }
            await fetch(url,{
                method:"POST",
                signal:signal,
                body:JSON.stringify(body),
                headers: {
                    'Content-Type': 'application/json;charset=utf-8',
                },
            })
                .then((response)=>response.json() as unknown as IFetchCommonResult)
                .then((result)=>{
                    if(result.success == false)
                    {
                        if(result.message.includes("Срок действия токена закончено"))
                        {
                            useUserStore.getState().logOut();
                            redirectToSignInPage();
                            return;
                        }
                        useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:result.message},2000);
                        return;
                    }

                    useAlertStore.getState().addAlert({uid:String(Date.now()),type:"success",message:result.message},2000);
                    useUserStore.getState().getFavourite();
                })
        },

        getHistory: async (limit, offset, inHand, signal)=>{
            if(!useUserStore.getState().token)
                return;

            set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:true}})
            const body = {
                token: useUserStore.getState().token,
                limit,
                offset,
                inHand: Number(inHand),
            }
            // console.log(body);
            let isAborted = false;
            try {

                await fetch(GET_USER_HISTORY_BOOKS_URL, {
                    signal: signal,
                    method:"POST",
                    headers: {
                        'Content-Type': 'application/json;charset=utf-8',
                    },
                    body:JSON.stringify(body)
                })
                    .then((response)=>response.json() as unknown as IFetchHistoryResult)
                    .then((result)=>{
                        if(result.success == false)
                        {
                            if(result.message.includes("Срок действия токена закончено"))
                            {
                                useUserStore.getState().logOut();
                                redirectToSignInPage();
                                return;
                            }
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:result.message},2000);
                            if(inHand){
                                set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false,inArmsBooks:{books:[],totalCount:0}}})
                            }
                            else
                            {
                                set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false,history:{books:[],totalCount:0}}})
                            }
                            return;
                        }
                        // console.log(result);
                        if(inHand){
                            set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false,inArmsBooks:{books:result.data.books,totalCount:result.data.count}}})
                        }
                        else
                        {
                            set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false,history:{books:result.data.books,totalCount:result.data.count}}})
                        }
                    })
                    .catch((e) => {
                        if(e.message === "The user aborted a request.")
                        {
                            isAborted = true
                        }
                        else
                        {
                            set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false}})
                            useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:"Не удалось загрузить избранное"},20000)
                        }
                    })

            }
            catch (e)
            {
                set({historyBooks:{...useUserStore.getState().historyBooks,isLoading:false}});
                useAlertStore.getState().addAlert({uid:String(Date.now()),type:"danger",message:`${e}`},2000);
                console.log(e);
            }
        },
        /*getHistoryBooksInArms: ()=>{
            const result:IHistoryBook[] = useUserStore.getState().historyBooks.books.filter((value:IHistoryBook)=>value.returnDate == null);
            return {books:result,totalCount:result.length}
        }*/
    }
))

export default useUserStore